import styled, { css } from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { colors } from 'common/styles/style-constants';
import { Icon } from 'opencare-crown';

import { FlexRow } from '../../../../common/styles/oc-styled-components';
 
export const ClinicSubRatingBadgeFlexRow = styled(FlexRow)`
  height: ${props => props.height || 'auto'};
  display: inline-flex;
  align-items: center;
  gap: 5px;

  padding: 0.125rem 0.625rem;
  border-radius: 0.25rem;

  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  font-size: 14px;
  line-height: normal;
  color: #9b1c1c;

  background-color: #fde8e8;

  ${({ isMinimal }) =>
    isMinimal
    && css`
      ${TYPOGRAPHY.OPEN_SANS.base};
      color: ${colors.slate};
      background: 0;
      padding: 0;
    `}
`;
 
export const ClinicSubRatingBadgeIcon = styled(Icon)`
  font-size: inherit;
  color: #9b1c1c;
`;
